import CustomHead from 'components/commons/CustomHead'
import PrivacyRecruit from 'components/privacy/agreement/recruit'

const AgreementRecruite: React.FC = () => {
  return (
    <div>
      <CustomHead
        keyword={''}
        image={'https://aitria.co.jp/img/ogp_logo.png'}
        url={'https://aitria.co.jp/agreement/recruit/'}
        title="採用応募における個人情報の取扱いについて | Aitria（アイトリア）"
        description=""
        noindexNofollow={true}
      />
      <PrivacyRecruit />
    </div>
  )
}

export default AgreementRecruite
